import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";
import { EASE } from "@/components/landing/Reveal";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease: EASE }}
        className="card-integra w-full max-w-md p-8 text-center">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
          <XCircle className="h-8 w-8 text-slate-400" />
        </span>
        <h1 className="mt-5 font-display text-xl font-extrabold text-slate-900">Paiement annulé</h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-500">
          Aucun montant n'a été prélevé. Vous pouvez repasser à Premium à tout moment depuis vos paramètres.
        </p>
        <Link to="/dashboard/parametres" className="btn-primary mx-auto mt-6 !px-8" data-testid="payment-cancel-back-link">
          Retour aux paramètres
        </Link>
      </motion.div>
    </div>
  );
}
